module.exports = __webpack_public_path__ + "img/office-reviews.e5b91271.png";